<style>
	.button-filter-active {
		background: #045532;
		border:none;
	}
	.button-filter-active strong {
		color: #f7f7f7;
	}

	.button-filter {
		background: #f7f7f7 !important;
		border:none;
	}	
	.button-filter strong {
		color: #222 !important;
	}
</style>
<template>
	<main class="mb-24 w-full">
		<!-- Content -->
  	<div id="content">
	  	<main class="vx-row justify-center md:mx-0 lg:mx-24 px-4 md:px-0">
	  		<div class="vx-col w-full md:w-5/6 lg:w-full xl:w-4/5">
	  			<header class="map mb-8">
	  				<!-- <img src="/assets/images/layanan-ambulance/map.svg" alt="" class="responsive" /> -->
	  				<GmapMap
		                :center="center"
		                :zoom="zoomMap"
		                map-type-id="terrain"
		                style="width: 100%; height: 400px">
		               <GmapMarker
		                    :key="index"
		                    v-for="(m, index) in markers"
		                    :position="m.position"
		                    :clickable="true"
		                    :draggable="true"
		                    :title="m.name"
		                    :label="m.type === 'pusat' ? m.name : undefined"
		                    :icon="m.icon"
		                    @click="center=m.position"
		                />
		            </GmapMap>
	  			</header>
	  			<!-- Form Search -->
	  			<vx-card class="mb-8" style="background: #f7f7f7;box-shadow: 0 0 0 #ccc;">
	  				<div class="vx-row">
	  					<div class="vx-col mb-4 lg:mb-0 w-full md:w-1/2 lg:w-1/4">
		  					<p class="mb-2"><strong>Provinsi</strong></p>
		  					<v-select
		  						class="w-full bg-white"
		  						v-model="provinsi"
		  						:options="provOptions"
		  					/>
		  				</div>
		  				<div class="vx-col  mb-4 lg:mb-0 w-full md:w-1/2 lg:w-1/4">
		  					<p class="mb-2"><strong>Kota/Kabupaten</strong></p>
		  					<v-select
		  						v-model="kota"
		  						class="w-full bg-white"
		  						:options="kotaOptions"
		  					/>
		  				</div>
		  				<div class="vx-col mb-4 lg:mb-0 w-full md:w-1/2 lg:w-1/4">
		  					<p class="mb-2"><strong>Kecamatan</strong></p>
		  					<v-select
		  						class="w-full bg-white"
		  						v-model="kecamatan"
		  						:options="kecamatanOptions"
		  					/>
		  				</div>
		  				<div class="vx-col mb-4 lg:mb-0 w-full md:w-1/2 lg:w-1/4">
		  					<p class="mb-2" style="opacity: 0;"><strong>Kecamatan</strong></p>
		  					<vs-button class="w-full " color="danger" @click.prevent="search">Search</vs-button>
		  				</div>
	  				</div>
		  				
	  			</vx-card>
	  			<!-- / -->

	  			<!-- Table Data -->
	  			<section class="data">
	  				<header class="vx-row justify-between items-center mb-8">
	  					<h5 class="vx-col w-full mb-4 "><strong>Hasil Pencarian</strong></h5>
	  					<div class="vx-col w-full flex justify-start" style="overflow-x: auto;">
	  						<button class="rounded-full button-filter-active wow px-3 mx-2" id="button-all" @click.prevent="filterSosAll(`button-all`)">
	  							<strong>
	  								Semua
	  							</strong>
	  						</button>
	  						<button
	  							v-for="(item, i) in subkategori"
	  							:key="i"
	  							class="rounded-full wow py-2 px-3 mx-2 button-filter"
	  							:id="`button-${i}`"
	  							@click.prevent="filterSos(item, `button-${i}`)"
	  						>
	  							<strong >{{item.name}}</strong>
	  						</button>
	  					</div>
	  				</header>
	  				<main class="p-6 rounded" style="background: #f7f7f7" v-if="data.length > 0">
	  					<section
	  						v-for="(item, i) in data"
	  						:key="i"
	  						class="mb-6"
	  					>
	  						<vx-card>
	  							<div class="vx-row justify-between items-center">
	  								<!-- Logo and name -->
	  								<div class="vx-col w-full md:w-1/2 flex flex-col md:flex-row justify-center md:justify-start">
									  	
	  									<img src="/assets/images/layanan-ambulance/sirine.svg" alt="" @click="showDetail(item)" class="block cursor-pointer w-1/4 md:w-1/6 mx-auto md:mx-0 mb-4 md:mb-0 md:mr-4 sm:mx-auto" />
	  									<div class="text-center md:text-left mb-4 md:mb-0 cursor-pointer"  @click="showDetail(item)">
	  										<strong class="mb-2 block">{{item.name}}</strong>

	  										<small v-if="item.kategori" class="mb-2 block">{{item.kategori.name}}</small>
	  										<small class="mb-2 block">{{item.pic}}</small>
	  										<small class="mb-2 block">{{item.kontak}}</small>
											<small v-if="item.kecamatan" class="mb-2 block">
												<strong class="block mr-3" v-if="item.kecamatan.kabkot">
													{{ item.kecamatan.kabkot.name }}
												</strong>
												<strong class="block">
													{{item.kecamatan.name}}
												</strong>
											</small>
	  									</div>
	  								</div>
	  								<!-- / -->
	  								<!-- Option -->
	  								<div class="vx-col w-full md:w-1/2 ">
	  									<div class="flex justify-center md:justify-end lg:hidden w-full">
	  										<a :href="item.chat_url" target="_blank" class="mx-4">
		  										<img src="/assets/images/layanan-ambulance/chat.svg" class="w-8" alt="" />
		  									</a>
	  									</div>
	  									<div class="flex items-center justify-end hidden lg:flex">
		  									<a :href="item.chat_url" target="_blank" class="mx-4">
		  										<img src="/assets/images/layanan-ambulance/chat.svg" class="w-8" alt="" />
		  									</a>
		  									<!-- <vs-button disabled color="danger">
		  										Pengajuan
		  									</vs-button> -->
	  									</div>
		  									
	  								</div>
	  								<!-- / -->
	  							</div>
	  						</vx-card>
	  					</section>
	  				</main>
	  				<main v-else class="w-full text-center">
	  					<strong>{{caption}}</strong>
	  				</main>
	  			</section>
	  			<!-- / -->
	  		</div>  		
	  	</main>
	</div>
  	<!-- / -->
  	<vs-popup class="modal"  title="" :active.sync="popupActive">
  		<div class="flex items-center justify-center">
			<!-- <a href="" class="mx-4">
				<img src="/assets/images/layanan-ambulance/phone.svg" class="w-8" alt="" />
			</a> -->
			<a href="" class="mx-4">
				<img src="/assets/images/layanan-ambulance/chat.svg" class="w-8" alt="" />
			</a>
			<!-- <a href="" class="mx-4">
				<img src="/assets/images/layanan-ambulance/info.svg" class="w-8" alt="" />
			</a> -->
			<!-- <vs-button color="danger">
				Pengajuan
			</vs-button> -->
		</div>
  	</vs-popup>

	  <!-- Detail  -->
	  <vs-popup class="modal" title="" :active.sync="popupDetail" fullscreen>
		  <section class="vx-row justify-center">
			  <div class="vx-col w-full md:w-5/6 lg:w-3/4">
				  	<div v-if="detailImage !== null" class="mb-6 flex justify-center">
						<img :src="detailImage" alt="" class="w-full md:w-1/3" />
					</div>
					<div v-html="detailContent" class="flex justify-center"></div>
			  </div>
				
		  </section>
			
	  </vs-popup>
	  <!-- / -->
	</main>
</template>
<script>
import vSelect from 'vue-select'
export default {
  created() {
  	this.getSubKategori()
  },
  mounted () {
    this.getProvinsi()
  },
  components: {
    vSelect
  },
  watch: {
    provinsi (val) {
      if (val !== null) {
        this.getKota(val.id)
        this.params = {
        	provinsi_id: val.id
        }

		if(this.kat_id !== null) {
			this.params.kat_id = this.kat_id
		}

		if(this.sub_id !== null) {
			this.params.sub_id = this.sub_id
		}

        // Jika mitra ada
        if(this.$route.query.mt) {
          this.params.user_id = this.$route.query.mt
        }

        this.getSos()
      }
	  else {
		  this.kota = null
		  this.kecamatan = null
		  this.params = {
			  kat_id: this.$route.params.id
		  }

			if(this.sub_id !== null) {
				this.params.sub_id = this.sub_id
			}

			// Jika mitra ada
			if(this.$route.query.mt) {
				this.params.user_id = this.$route.query.mt
			}

			this.getSos()
	  }
    },
    kota (val) {
      if (val !== null) {
      	this.params = {
        	provinsi_id: this.provinsi.id,
        	kabkot_id: val.id
        }

		if(this.kat_id !== null) {
			this.params.kat_id = this.kat_id
		}

		if(this.sub_id !== null) {
			this.params.sub_id = this.sub_id
		}

        // Jika mitra ada
        if(this.$route.query.mt) {
          this.params.user_id = this.$route.query.mt
        }

        this.getKecamatan(val.id)
        this.getSos()
      }
	  else {
		  this.kecamatan = null
		  this.params = {
			  kat_id: this.$route.params.id
		  }

			if(this.sub_id !== null) {
				this.params.sub_id = this.sub_id
			}

			if(this.provinsi !== null) {
				this.params.provinsi_id = this.provinsi.id
			}

			// Jika mitra ada
			if(this.$route.query.mt) {
				this.params.user_id = this.$route.query.mt
			}

			this.getSos()
	  }
    },
    kecamatan(val) {
    	if (val !== null) {
      	this.params = {
        	provinsi_id: this.provinsi.id,
        	kabkot_id: this.kota.id,
        	kecamatan_id: this.kecamatan.id,
        }

		if(this.kat_id !== null) {
			this.params.kat_id = this.kat_id
		}

		if(this.sub_id !== null) {
			this.params.sub_id = this.sub_id
		}

        // Jika mitra ada
        if(this.$route.query.mt) {
          this.params.user_id = this.$route.query.mt
        }
        this.getSos()
      }	
	  else {
		  this.params = {
			  kat_id: this.$route.params.id
		  }

			if(this.sub_id !== null) {
				this.params.sub_id = this.sub_id
			}

			if(this.provinsi !== null) {
				this.params.provinsi_id = this.provinsi.id
			}

			if(this.kota !== null) {
				this.params.kabkot_id = this.kota.id
			}

			// Jika mitra ada
			if(this.$route.query.mt) {
				this.params.user_id = this.$route.query.mt
			}

			this.getSos()
	  }
    }
	
  },
  methods: {
	showDetail(item) {
		this.detailImage = null
		this.detailContent = null

		// Show image if exists
		if(item.file !== null && item.file != '') {
			this.detailImage = process.env.VUE_APP_STORAGE + '/' + item.file
		}

		this.detailContent = `<div>
			<h4 class="mb-4">${item.name}</h4>
			<ul class="mb-6">`
			
		if(item.alamat !== null) {
			this.detailContent += `<li><strong>Alamat: ${ item.kecamatan.name }</strong></li>`
		}

		if(item.kecamatan !== null) {
			this.detailContent += `<li><strong>Kecamatan: ${ item.kecamatan.name }</strong></li>`

			if(item.kecamatan.kabkot !== null) {
				this.detailContent += `<li><strong>Kabupaten/Kota: ${ item.kecamatan.kabkot.name }</strong></li>`

				if(item.kecamatan.kabkot.provinsi !== null) {
					this.detailContent += `<li><strong>Provinsi: ${ item.kecamatan.kabkot.provinsi.name }</strong></li>`
				}
			}
		}		

		this.detailContent += `</ul>`
		
		// Deskripsi
		if(item.deskripsi !== null) {
			this.detailContent += `<div class="mb-6">
				<h4 class="mb-4">Deskripsi</h4>
				<p>${item.deskripsi}</p>
			</div>`
		}

		// PIC
		if(item.pic !== null) {
			this.detailContent += `<div class="mb-4">
				<p>PIC: ${item.pic}</p>
			</div>`
		}

		if(item.kontak !== null) {
			this.detailContent += `<div class="mb-4">
				<p>Kontak PIC: ${item.kontak}</p>
			</div>`
		}

		this.detailContent += `</div>`
		this.popupDetail = true
	},
  	filterSosAll(id) {
		this.sub_id = null
		this.kat_id = this.$route.params.id
  		document.getElementsByClassName('wow').forEach(item => {
  			item.setAttribute('class', 'button-filter px-4 py-3 mx-2 wow rounded-full')
  		})

  		document.getElementById(id).setAttribute('class', 'button-filter-active px-4 py-3 mx-2 wow rounded-full')

  		this.params = {
  			kat_id: this.kat_id
  		}

      // Jika mitra ada
      if(this.$route.query.mt) {
        this.params.user_id = this.$route.query.mt
      }

  		if(this.provinsi !== null) {
  			this.params.provinsi_id = this.provinsi.id
  		}

  		if(this.kota !== null) {
  			this.params.kabkot_id = this.kota.id
  		}

  		if(this.kecamatan !== null) {
  			this.params.kecamatan_id = this.kecamatan.id
  		}

  		this.activeSubs = this.subs_id.join(',')

  		this.getSos()
  	},
  	filterSos(item, id) {
  		this.kat_id = this.kat_id
		this.sub_id = item.id
  		document.getElementsByClassName('wow').forEach(item => {
  			item.setAttribute('class', 'button-filter px-4 py-3 mx-2 wow rounded-full')
  		})

  		document.getElementById(id).setAttribute('class', 'button-filter-active px-4 py-3 mx-2 wow rounded-full')

  		this.params = {
			kat_id: this.kat_id,
  			sub_id: item.id
  		}

      // Jika mitra ada
      if(this.$route.query.mt) {
        this.params.user_id = this.$route.query.mt
      }

  		if(this.provinsi !== null) {
  			this.params.provinsi_id = this.provinsi.id
  		}

  		if(this.kota !== null) {
  			this.params.kabkot_id = this.kota.id
  		}

  		if(this.kecamatan !== null) {
  			this.params.kecamatan_id = this.kecamatan.id
  		}

  		this.activeSubs = item.id

  		this.getSos()

  	},
  	getSos() {
  		this.$vs.loading()
  		this.$store.dispatch('region/search', this.params)
  		.then(sos => {
  			this.$vs.loading.close()
  			sos.map(item => {
	            const num = item.kontak.split('-').join('').replace('0', '62')
	            item.chat_url = this.wa_me + num
	          })
  			this.data = sos
  			// update marker map
	        this.markers = []
	          if (this.data.length > 0) {
				const firstLat = parseFloat(this.data[0].latitude),
					firstLng = parseFloat(this.data[0].longitude)
				this.center = { lat: firstLat, lng: firstLng }
				this.data.map(item => {
					const lat = parseFloat(item.latitude),
					lng = parseFloat(item.longitude)
					let zonasi = item.zonasi

					if(zonasi.length > 0) {
						// get lat & long of each zonasi (zona operasi)
						zonasi.map(zon => {
							const latLong = JSON.parse(zon.meta)
							
							if(latLong) {
								
								// add zona operasi suatu layanan ke marker
								this.markers.push({
									type: 'operasional',
									name: 'zonasi ' + zon.name,
									position: {
										lat: parseFloat(latLong.lat),
										lng: parseFloat(latLong.long)
									},
									icon: require('@/../public/assets/images/layanan-ambulance/sirine-zonasi-marker.png')
								})

							}
						})
					}

					// Add posisi layanan to marker
					this.markers.push({
						type: 'pusat',
						name: item.name,
						position: {
							lat,
							lng
						},
						icon: require('@/../public/assets/images/layanan-ambulance/sirine-marker.png')
					})
				})
				
	        } else {
	            this.markers = []
	            this.caption = 'Tidak ada layanan di daerah tersebut'
	        }
  		})
  		.catch(e => {
  			this.$vs.loading.close()
  			if(e.response) {
  				console.error(e.response)
  			}

  			return false
  		})
  	},
    getSosCategory() {
      this.$store.dispatch('sos/getCategory')
      .then(category => {
        if(category.length > 0) {
          const datas = category.slice()
          datas.forEach(item => {
            item.icon = `/assets/images/sos/${item.name.toLowerCase()}.png`
          })
          this.sosCategory = datas
        }
      })
    },
    search () {

      this.params = {}

	  if(this.kat_id !== null) {
		  this.params.kat_id = this.kat_id
		  
	  }
	  if(this.sub_id !== null) {
			this.params.sub_id = this.sub_id
	  }

      if(this.provinsi !== null) {
        this.params.provinsi_id = this.provinsi.id
      }

      if(this.kota !== null) {
        this.params.kabkota_id = this.kota.id
      }

      if(this.kecamatan !== null) {
        this.params.kecamatan_id = this.kecamatan.id
      }

      // Jika mitra ada
      if(this.$route.query.mt) {
        this.params.user_id = this.$route.query.mt
      }

      this.getSos()
    },
    getSubKategori () {
      this.$vs.loading()
      this.$store.dispatch('sos/getSubKategori', {
      	kat_id: this.$route.params.id
      })
        .then(subkategori => {
          this.$vs.loading.close()
          subkategori.forEach(item => {
          	item.label = item.name
          	item.active = false
          	this.subs_id.push(item.id)
          })
          this.subkategori = subkategori
			this.kat_id = this.$route.params.id
          this.params = {
          	kat_id: this.kat_id
          }

          // Jika mitra ada
          if(this.$route.query.mt) {
            this.params.user_id = this.$route.query.mt
          }

          // Get sos
          this.getSos()
        })
        .catch(() => this.$vs.loading())
    },
    getKecamatan (kota_id) {
      this.$vs.loading()
      this.$store.dispatch('region/getKecamatan', {kabkot_id:kota_id})
        .then(kecamatan => {
          this.$vs.loading.close()
          kecamatan.forEach(item => {
          	item.label = item.name
          })
          this.kecamatanOptions = kecamatan
        })
        .catch(e => {
          this.$vs.loading.close()
          console.error(e)
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    },
    getKota (provinsi_id) {
      this.$vs.loading()
      this.$store.dispatch('region/getKota', {provinsi_id})
        .then(kota => {
          this.$vs.loading.close()
          kota.forEach(item => {
          	item.label = item.name
          })
          this.kotaOptions = kota
        })
        .catch(e => {
          this.$vs.loading.close()
          console.error(e)
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    },
    getProvinsi () {
      this.$store.dispatch('region/getProvinsi')
        .then(provinsi => {
          provinsi.forEach(item => {
          	item.label = item.name
          })
          this.provOptions = provinsi
        })
        .catch(e => {
          console.error(e)
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    }
  },
  data: () => ({
	  detailImage: null,
	detailContent: null,
  	params: {},
	  kat_id: null,
	  sub_id: null,
  	activeSubs: [],
  	subs_id: [],
  	allColor: 'primary',
  	allTextColor: 'text-white',
    wa_me: 'https://wa.me/',
    caption: 'Harap pilih wilayah',
    selectedKategori: null,
    subkategori: [],
    center: { lat: -6.914744, lng: 107.609810 },
    markers: [{ position: { lat: -6.914744, lng: 107.609810 } }],
    zoomMap: 8,
    provinsi: null,
    kota: null,
    kecamatan: null,
    popupActive: false,
	popupDetail: false,
    data: [],
    kotaOptions: [],
    kecamatanOptions: [],
    sosCategory: [],
    category: null,
    category_id: null,
    provOptions: [
      {
        id: 1,
        label: 'Jawa Barat'
      },
      {
        id: 2,
        label: 'DKI Jakarta'
      }
    ]
  })
}
</script>